import {
  GetCustomTimeRangeCategoriesDocument,
  UpdateCustomTimeRangeCategoryDocument,
  UpdateCustomTimeRangeCategoryMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpdateCustomTimeRangeCategory = () => {
  const [updateCustomTimeRangeCategory, { loading }] = useMutation(
    UpdateCustomTimeRangeCategoryDocument,
    {
      extractorFn: (data) => data.attendanceMutations.updateAttendanceCustomTimeRangeCategory,
    }
  )

  const update = (variables: UpdateCustomTimeRangeCategoryMutationVariables) => {
    return updateCustomTimeRangeCategory({
      variables,
      refetchQueries: [GetCustomTimeRangeCategoriesDocument],
    })
  }

  return {
    loading,
    update,
  }
}
